import React, { useContext, useEffect, useState } from 'react';
import { Navbar, Button } from 'react-bootstrap';
import { ArrowLeft } from 'react-feather';
import styled, { css } from 'styled-components';
import { OptionContext } from '../../contexts/OptionContext';
import { OrchestratorContext } from '../../contexts/OrchestratorContext';

const BotNavbarBrand = styled.div`
  position: absolute;
  text-align: center;
  width: 100vw;
`;

const ButtonCustom = styled(Button)`
  z-index: 1000;
`;

const BotNavbar = styled(Navbar)`${(props) => css`
    background-color: ${props.background};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 1000;
  `
}`;

const ArrowLeftCustom = styled(ArrowLeft)`${(props) => css`
    color: ${props.foreground}
  `
}`;

const Transition = styled.div`
  @media (min-width: 769px) {
    .active {
      visibility: visible;
      transition: all 200ms ease-in;
    }
    .hidden {
      visibility: hidden;
      transition: all 200ms ease-out;
      transform: translate(0, -100%);
    }
  }
`;

const Header = () => {
  const contextOption = useContext(OptionContext);
  const contextOrchestrator = useContext(OrchestratorContext);

  const { header } = contextOption;
  const { returnCheckpoint } = contextOrchestrator;
  const [scrollPos, setScrollPos] = useState(0);
  const [showScroll, setShowScroll] = useState(true);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;

    if (scrollPos > currentScrollPos) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
    setScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollPos, showScroll, handleScroll]);

  return (
    <Transition>
      <BotNavbar background={header.background} className={`py-2 px-0 ${showScroll ? 'active' : 'hidden'}`} variant="transparent">
        <ButtonCustom variant="link" onClick={returnCheckpoint} className="mr-auto">
          <ArrowLeftCustom foreground={header.foreground} size="28" className="mr-auto c-white" strokeWidth="0.08rem" />
        </ButtonCustom>
        <BotNavbarBrand>
          <img src={header.icon} height={header.iconSize} alt="..." />
          {header.icon2
            && (
              <>
                <span className="c-white ml-3 mr-3  pt-3 font-size-lg">+</span>
                <img src={header.icon2} height={header.iconSize} alt="..." />
              </>
            )}
        </BotNavbarBrand>
      </BotNavbar>
    </Transition>
  );
};

export default Header;
